export default {
}



// WEBPACK FOOTER //
// src/store/authen/qrcode/getters.js